const SET_AUTOSAVE_TIMEOUT_ID = 'timeout/SET_AUTOSAVE_TIMEOUT_ID';
const SET_AUTOSAVE_ENABLED = 'timeout/SET_AUTOSAVE_ENABLED';

const initialState = {
    autoSaveTimeoutId: null,
    autoSaveEnabled: localStorage.getItem("AUTO_SAVE")==="true"
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_AUTOSAVE_TIMEOUT_ID:
        return Object.assign({}, state, {
            autoSaveTimeoutId: action.id
        });
    case SET_AUTOSAVE_ENABLED:
        localStorage.setItem("AUTO_SAVE",action.enabled)
        return Object.assign({}, state, {
            autoSaveEnabled: action.enabled
        });
    default:
        return state;
    }
};
const setAutoSaveTimeoutId = id => ({
    type: SET_AUTOSAVE_TIMEOUT_ID,
    id
});
const setAutoSaveEnabled = enabled => ({
    type: SET_AUTOSAVE_ENABLED,
    enabled
});

export {
    reducer as default,
    initialState as timeoutInitialState,
    setAutoSaveEnabled,
    setAutoSaveTimeoutId
};
